import * as Sentry from '@sentry/react'

export function initializeSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  const environment = import.meta.env.VITE_APP_ENV

  if (!dsn && import.meta.env.DEV) {
    return
  }

  if (!dsn && environment === 'test') {
    return
  }

  if (!dsn) {
    throw new Error('VITE_SENTRY_DSN is required in production environments')
  }

  try {
    Sentry.init({
      dsn,
      environment,
      integrations: [
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
        // Performance monitoring
        Sentry.browserTracingIntegration(),
      ],

      tracesSampleRate: environment === 'production' ? 0.1 : 1.0,

      // Session replay sample rates
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0,

      beforeSend(event) {
        if (event.request?.url) {
          event.request.url = scrubSensitiveInfo(event.request.url)
        }

        return event
      },

      initialScope: {
        tags: {
          component: 'frontend',
        },
        level: 'error',
      },
    })

    return true
  } catch {
    throw new Error('Failed to initialize Sentry')
  }
}

function scrubSensitiveInfo(url: string): string {
  try {
    const urlObj = new URL(url)

    const sensitiveParams = ['token', 'key', 'secret', 'password', 'auth']
    sensitiveParams.forEach((param) => {
      if (urlObj.searchParams.has(param)) {
        urlObj.searchParams.set(param, '[Filtered]')
      }
    })

    return urlObj.toString()
  } catch {
    return '[Invalid URL]'
  }
}

export function setSentryUser(user: {
  id: string
  email?: string
  role?: string[]
}) {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    role: user.role?.[0] || 'user',
  })
}

export function clearSentryUser() {
  Sentry.setUser(null)
}
